<template>
        <el-dialog
            class="updateTimeDialog"
            title="抵达"
            :close-on-click-modal="false"
            width="350px"
            :visible.sync="updateTimeVisiable"
            :before-close="handleClose">
            <el-form
            :label-position="'right'"
            :model="AdmittRuleForm"
            label-width="90px"
            ref="AdmittRuleForm"
            class="rowIndex"
            >
             <el-form-item
                label="发车单号"
                prop="dispatchNo"
                class="label-form"
                >
                <el-input
                    clearable
                    :disabled="true"
                    v-model.trim="AdmittRuleForm.dispatchNo"
                    size="mini"
                    class="dispatch"
                ></el-input>
            </el-form-item>
            <el-form-item
                label="接单时间"
                prop="receiveTime"
                class="label-form"
                >
                <el-date-picker
                    v-model="AdmittRuleForm.receiveTime"
                    :disabled="Boolean(AdmittRuleForm.arriTime)"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                    :picker-options="start_date"
                ></el-date-picker>
            </el-form-item>
            <el-form-item
                label="承运结束时间"
                prop="arriTime"
                class="label-form"
                >
                <el-date-picker
                    v-model="AdmittRuleForm.arriTime"
                    :disabled="Boolean(AdmittRuleForm.receiveTime)"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                ></el-date-picker>
            </el-form-item>
            <div class="time">清空接单时间才可以编辑承运结束时间</div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="dialog-btn" @click="handleClose">取 消</el-button>
                <el-button class="dialog-cel" type="primary" @click="saveOk">保 存</el-button>
            </div>
        </el-dialog>
</template>
<script>
import { getUpdateLists } from '../../../../api/vehicleFreePlatform';
import dayjs from 'dayjs';
export default {
    props: {
        updateTimeVisiable: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            AdmittRuleForm: {
                dispatchNo: '',
                receiveTime: '',
                arriTime: ''
            },
            oldReceiveTime: '',
            start_date: {// 开始时间范围限定
                disabledDate: time => {
                    if (this.oldReceiveTime) {
                        const a = dayjs(this.oldReceiveTime).format('YYYY-MM-DD');
                        const b = dayjs(a).valueOf();
                        return (time.getTime() >= b + 24 * 60 * 60 * 1000 || time.getTime() <= b);
                    }
                }
            }
        };
    },
    methods: {
        handleClose() {
            this.$emit('update:updateTimeVisiable', false);
        },
        saveOk() {
            getUpdateLists(this.AdmittRuleForm).then(res => {
                if (res) {
                    this.$message.success('更新时间成功');
                    this.$emit('updateTimeSaveOk');
                }
            });
        }
    },
    mounted() {
        this.AdmittRuleForm.dispatchNo = this.rowData.dispatchNo;
        this.AdmittRuleForm.receiveTime = this.rowData.receiveTime;
        this.AdmittRuleForm.arriTime = this.rowData.arriTime;
        this.oldReceiveTime = this.rowData.receiveTime;
    }
};
</script>
<style lang="less">
    @width: 220px;
    .dispatch{
        width: @width;
    }
    .time{
        text-align: center;
    }
</style>